import { Link as RouterLink } from 'react-router-dom'
import { Box, Container, Divider, Link, Typography } from '@mui/material'

import Page from 'src/components/Page'
import { PrivacyPolicyContent } from 'src/content/privacyPolicy'

export function PublicPrivacyPage() {
  return (
    <Page title="BatiKal | Politique de confidentialité">
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: { xs: 3, sm: 4 }, pb: 6 }}>
        <Container maxWidth="md">
          <Box sx={{ mb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
            <Typography
              component={RouterLink}
              to="/"
              sx={{
                fontWeight: 800,
                fontSize: '1.25rem',
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}>
              BatiKal
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Link component={RouterLink} to="/cgu" color="inherit" underline="hover" sx={{ mr: 2 }}>
                CGU
              </Link>
              <Link component={RouterLink} to="/login" color="inherit" underline="hover">
                Connexion
              </Link>
            </Typography>
          </Box>

          <Box
            sx={{
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              p: { xs: 2.5, sm: 4 }
            }}>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1, lineHeight: 1.2 }}>
              POLITIQUE DE CONFIDENTIALITÉ – BATIKAL
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <PrivacyPolicyContent />
          </Box>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2, textAlign: 'center' }}>
            <Link href="mailto:contact@batikal-app.com">contact@batikal-app.com</Link>
          </Typography>
        </Container>
      </Box>
    </Page>
  )
}
